import { IProject } from 'redux-store/api/projects';
import { PhaseStatusesEnum } from 'redux-store/types';
import {
  PhaseFilterStatusesEnum,
  TRowElementColorHelper,
} from 'pages/project-dashboard/sections/schedule/types';
import { TSidebarProjectItems } from 'pages/all-projects-dashboard/types';

export const rowElementColorHelper: TRowElementColorHelper = (color: string) => {
  switch (color) {
    case '#D12D36':
      return {
        color: '#D12D36',
        resize: '#f27c81',
        text: 'black',
        itemText: '#23252F',
        phaseText: 'white',
        resizeButton: '#FFFFFF',
        light: '#FFF8F9',
      };

    case '#42A9BF':
      return {
        color: '#42A9BF',
        resize: '#82b7c2',
        text: 'white',
        itemText: '#23252F',
        phaseText: 'white',
        resizeButton: '#FFFFFF',
        light: '#EEF6F7',
      };

    case '#FF7051':
      return {
        color: '#FF7051',
        resize: '#f09d8b',
        text: 'white',
        itemText: '#23252F',
        phaseText: 'white',
        resizeButton: '#FFFFFF',
        light: '#FFF2EF',
      };

    case '#9648C6':
      return {
        color: '#9648C6',
        resize: '#ad7fc9',
        text: 'white',
        itemText: '#23252F',
        phaseText: 'white',
        resizeButton: '#FFFFFF',
        light: '#F4E7FC',
      };

    case '#D3AC1E':
      return {
        color: '#D3AC1E',
        resize: '#dbc267',
        text: 'white',
        itemText: '#23252F',
        phaseText: 'white',
        resizeButton: '#FFFFFF',
        light: '#F9F5E6',
      };

    case '#3652C6':
      return {
        color: '#3652C6',
        resize: '#6d7dbd',
        text: 'white',
        itemText: '#23252F',
        phaseText: 'white',
        resizeButton: '#FFFFFF',
        light: '#E9EEFF',
      };

    case '#BD30B7':
      return {
        color: '#BD30B7',
        resize: '#c270be',
        text: 'white',
        itemText: '#23252F',
        phaseText: 'white',
        resizeButton: '#FFFFFF',
        light: '#FFF2FF',
      };

    case '#15682D':
      return {
        color: '#15682D',
        resize: '#5a8f69',
        text: 'white',
        itemText: '#23252F',
        phaseText: 'white',
        resizeButton: '#FFFFFF',
        light: '#F4FCF3',
      };

    case '#FCA311':
      return {
        color: '#FCA311',
        resize: '#f0be6c',
        text: 'white',
        itemText: '#23252F',
        phaseText: 'white',
        resizeButton: '#FFFFFF',
        light: '#FFEED0',
      };

    case '#D4A373':
      return {
        color: '#D4A373',
        resize: '#d4b698',
        text: 'white',
        itemText: '#23252F',
        phaseText: 'white',
        resizeButton: '#FFFFFF',
        light: '#EEEAE7',
      };

    case '#FF006E':
      return {
        color: '#FF006E',
        resize: '#f584b5',
        text: 'white',
        itemText: '#23252F',
        phaseText: 'white',
        resizeButton: '#FFFFFF',
        light: '#FFEEF6',
      };

    case '#06D6A0':
      return {
        color: '#06D6A0',
        resize: '#80d9c2',
        text: 'white',
        itemText: '#23252F',
        phaseText: 'white',
        resizeButton: '#FFFFFF',
        light: '#EBFFFA',
      };

    case '#7678ED':
      return {
        color: '#7678ED',
        resize: '#b2b3eb',
        text: 'white',
        itemText: '#23252F',
        phaseText: 'white',
        resizeButton: '#FFFFFF',
        light: '#F2F2FD',
      };

    case '#C9F299':
      return {
        color: '#C9F299',
        resize: '#def0c9',
        text: 'black',
        itemText: '#23252F',
        phaseText: 'white',
        resizeButton: '#FFFFFF',
        light: '#EFF7E6',
      };

    case '#F3F956':
      return {
        color: '#F3F956',
        resize: '#f2f5a2',
        text: 'black',
        itemText: '#23252F',
        phaseText: 'black',
        resizeButton: '#FFFFFF',
        light: '#FFFFF2',
      };

    case '#97FF30':
      return {
        color: '#97FF30',
        resize: '#bff788',
        text: 'black',
        itemText: '#23252F',
        phaseText: 'white',
        resizeButton: '#FFFFFF',
        light: '#F3FFE6',
      };

    case '#04BF7B':
      return {
        color: '#04BF7B',
        resize: '#78d6b4',
        text: 'white',
        itemText: '#23252F',
        phaseText: 'white',
        resizeButton: '#FFFFFF',
        light: '#B8F8E0',
      };

    case '#05F2F2':
      return {
        color: '#05F2F2',
        resize: '#87ffff',
        text: 'black',
        itemText: '#23252F',
        phaseText: 'white',
        resizeButton: '#FFFFFF',
        light: '#A8FAFA',
      };

    case '#000000':
      return {
        color: '#000000',
        resize: '#545454',
        text: 'white',
        itemText: '#23252F',
        phaseText: 'white',
        resizeButton: '#FFFFFF',
        light: '#999999',
      };

    case '#964B00':
      return {
        color: '#964B00',
        resize: '#9e6d3c',
        text: 'white',
        itemText: '#23252F',
        phaseText: 'white',
        resizeButton: '#FFFFFF',
        light: '#DFB199',
      };

    case '#FF9900':
      return {
        color: '#FF9900',
        resize: '#fabd61',
        text: 'white',
        itemText: '#23252F',
        phaseText: 'white',
        resizeButton: '#FFFFFF',
        light: '#FFD699',
      };

    case '#674EA7':
      return {
        color: '#674EA7',
        resize: '#8374a8',
        text: 'white',
        itemText: '#23252F',
        phaseText: 'white',
        resizeButton: '#FFFFFF',
        light: '#C2B0E5',
      };

    case '#FFFF00':
      return {
        color: '#FFFF00',
        resize: '#fafa93',
        text: 'black',
        itemText: '#23252F',
        phaseText: 'black',
        resizeButton: '#FFFFFF',
        light: '#FFFFCC',
      };

    case '#4285F4':
      return {
        color: '#4285F4',
        resize: '#7faefa',
        text: 'white',
        itemText: '#23252F',
        phaseText: 'white',
        resizeButton: '#FFFFFF',
        light: '#C7E0FB',
      };

    case '#FF00AB':
      return {
        color: '#FF00AB',
        resize: '#fc74d0',
        text: 'white',
        itemText: '#23252F',
        phaseText: 'white',
        resizeButton: '#FFFFFF',
        light: '#FF99E6',
      };

    case '#00FFFF':
      return {
        color: '#00FFFF',
        resize: '#a2fafa',
        text: 'black',
        itemText: '#23252F',
        phaseText: 'black',
        resizeButton: '#FFFFFF',
        light: '#99FFFF',
      };

    default:
      return {
        color: color,
        resize: color,
        text: 'white',
        itemText: 'white',
        phaseText: 'white',
        resizeButton: '#FFFFFF',
        light: color,
      };
  }
};

export const scheduleFilteredData = (
  projectData: IProject,
  selectedPhase: string,
  selectedPhaseItems: string,
  selectedStatus: string,
  searchValue: string
) => {
  if (projectData) {
    let phases = projectData?.phases;

    if (selectedPhase) {
      phases = phases?.filter(({ id }) => id === Number(selectedPhase));
    }

    if (selectedPhaseItems) {
      phases = phases.map((phase) => ({
        ...phase,
        items: phase?.items?.filter((item) => item?.id === Number(selectedPhaseItems)),
      }));
    }

    if (selectedStatus && selectedStatus !== PhaseFilterStatusesEnum.ALL) {
      if (selectedStatus === PhaseFilterStatusesEnum.ALL_BUT_COMPLETED) {
        phases = phases?.map((phase) => ({
          ...phase,
          items: phase.items.filter((item) => {
            return item.status !== PhaseStatusesEnum.COMPLETED;
          }),
        }));
      } else {
        phases = phases?.map((phase) => ({
          ...phase,
          items: phase.items.filter((item) => {
            return item.status === selectedStatus;
          }),
        }));
      }
    }

    if (selectedStatus && !selectedPhase) {
      phases = phases.filter(({ items }) => items?.length > 0);
    }

    if (searchValue) {
      const phaseRow = phases.filter((phase) =>
        phase?.title?.toLowerCase()?.includes(searchValue?.toLowerCase())
      );

      phases = phases.reduce(
        (acc, cur) => {
          const items = cur.items.filter((item) => {
            return item.title?.toLowerCase()?.includes(searchValue?.toLowerCase());
          });
          if (items.length && !phaseRow.find((item) => item.title === cur.title)) {
            acc.push({
              ...cur,
              items: items,
            });
          }
          return acc;
        },
        [...phaseRow]
      );
    }

    return phases;
  }

  return [];
};

function getSelectedProjects(selectedProjectsList: TSidebarProjectItems[]) {
  if (!selectedProjectsList) return null;

  return selectedProjectsList?.filter((item) => item.isSelected);
}

export const scheduleFilteredProjects = (
  projects: IProject[],
  selectedPhase: string,
  selectedPhaseItems: string,
  selectedStatus: string,
  searchValue: string,
  selectedProjectsList?: TSidebarProjectItems[]
): IProject[] => {
  const filteredProjectsList = getSelectedProjects(selectedProjectsList);

  const projectsData = !!filteredProjectsList ? filteredProjectsList : projects;

  if (!projectsData?.length) return [];

  return projectsData.map((project) => ({
    ...project,
    phases: scheduleFilteredData(
      project,
      selectedPhase,
      selectedPhaseItems,
      selectedStatus,
      searchValue
    ),
  }));
};
